"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.view = exports.sort = exports.subType = void 0;
var subType;
(function (subType) {
    subType["Airport"] = "AIRPORT";
    subType["City"] = "CITY";
})(subType || (exports.subType = subType = {}));
var sort;
(function (sort) {
    sort["Traveller_Score"] = "analytics.travelers.score";
})(sort || (exports.sort = sort = {}));
var view;
(function (view) {
    view["Light"] = "LIGHT";
    view["Full"] = "FULL";
})(view || (exports.view = view = {}));
